import { executeSoon } from '@streamr/tv-utils';
import { useCallback, useEffect, useState } from 'react';
export function useShare() {
    const [canShare, setCanShare] = useState(false);
    useEffect(() => {
        setCanShare(typeof navigator.share === 'function');
    }, []);
    const openSystemShareDialog = useCallback((url, options = {}) => {
        if (!canShare) {
            return;
        }
        executeSoon(async () => {
            try {
                const { title = 'Check out my live stream!', text = url } = options;
                await navigator.share({
                    title,
                    text,
                    url,
                });
            }
            catch (error) {
                if (error instanceof Error) {
                    switch (error.name) {
                        case 'AbortError':
                        case 'InvalidStateError':
                            return;
                    }
                }
                console.error('Error sharing', error);
            }
        });
    }, [canShare]);
    return {
        canShare,
        openSystemShareDialog,
    };
}
